<template>
    <component
        :is="buttonComponent"
        class="button-block"
        type="button"
        :class="buttonClasses"
        :disabled="buttonDisabled"
        :to="buttonRoute"
        @click="buttonClick(buttonClickParams)"
    >
        {{ buttonText }}
    </component>
</template>

<script>
export default {
    name: 'ButtonBlock',
    props: {
        buttonColor: {
            required: false,
            type: String,
            default: 'bg-indigo-600 text-white hover:bg-indigo-500 focus-visible:outline-indigo-600',
        },
        buttonDisabled: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
    },
    computed: {
        buttonComponent() {
            return this.buttonRoute ? 'router-link' : 'button';
        },
        buttonClasses() {
            const cls = {};
            cls['inline-block'] = true;
            cls['w-full px-4 py-3'] = true;
            cls['rounded-md shadow-xs'] = true;
            cls['focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2'] = true;
            cls['text-lg font-bold'] = true;
            cls[this.buttonColor] = true;
            cls['disabled:bg-zinc-500'] = !!this.buttonDisabled;
            return cls;
        },
    },
};
</script>
